import { colorUsage } from 'stylesheetB2c';
import type { SwipeColors } from 'types/swipeColors';

import { s3Client } from './client';

export const COLOR_SETTINGS_PARENT_FOLDER = 'song-color-settings';
const SWIPE_COLORS_FILENAME = 'swipe-colors.json';

export const getSwipeColor = async (colorSetting: string): Promise<SwipeColors> => {
  try {
    const swipeColorUrl = [
      process.env.REACT_APP_ASSETS_BASE_URL,
      COLOR_SETTINGS_PARENT_FOLDER,
      colorSetting,
      SWIPE_COLORS_FILENAME,
    ].join('/');
    const textResponse = await s3Client.get(swipeColorUrl, true);
    return JSON.parse(textResponse) as SwipeColors;
  } catch {
    return colorUsage.mp3KbpPlayer.lyricsDefaultSwipeColors;
  }
};
